import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PdfDataExtractionFilters from '../components/PdfDataExtractionFilters';
import TopBar from '../../../components/TopBar';
import PDFDataExtractionTable from '../components/PDFDataExtractionTable';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Stack } from '@mui/material';
import FeatureNotSupportedDialog from '../../common/FeatureNotSupportedDialog';
import { fetchPdfDataExtractionRequest } from '../../../api/pdfDataExtraction/pdfDataExtractionSlice';
import useSessionPersistedState from '../../../hooks/useSessionPersistedState';

const filters = [
  {
    type: 'search',
    options: [
      {
        key: 'filename',
        placeholder: 'File Name',
      },
      {
        key: 'status',
        placeholder: 'Status',
      },
      {
        key: 'created_on',
        placeholder: 'Date',
      },
    ],
  },
];

const PERSIST_KEY = 'ai-tools/pdf-data-extraction';

function PdfDataExtractionListPage() {
  useDocumentTitle('Pdf Data Extraction');
  const dispatch = useDispatch();
  const [selectedFilter, setSelectedFilter] = useSessionPersistedState(
    `${PERSIST_KEY}:selectedFilter`,
    filters.length > 0 ? filters[0].options[0].key : '',
  );
  const [searchTerm, setSearchTerm] = useSessionPersistedState(`${PERSIST_KEY}:searchTerm`, '');
  const [currentQuery, setCurrentQuery] = useSessionPersistedState(`${PERSIST_KEY}:currentQuery`, {});
  const subscription = useSelector((state) => state.subscription.subscription);
  const isPDFDataExtractionFeatureEnabled = subscription?.features?.enable_pdf_data_extraction;

  useEffect(() => {
    if (!isPDFDataExtractionFeatureEnabled) return;
    const query = { ...currentQuery };
    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }
    dispatch(fetchPdfDataExtractionRequest({ query: Object.keys(query).length ? query : {} }));
  }, [dispatch, isPDFDataExtractionFeatureEnabled]);

  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
    const searchBy = event.target.value;
    const query = { page: 0, size: 10 };
    if (searchTerm) {
      query[searchBy] = searchTerm;
    }
    setCurrentQuery(query);
    dispatch(
      fetchPdfDataExtractionRequest({
        query,
      }),
    );
  };

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handleSearchKeyPress = (event) => {
    const query = { page: 0, size: 10 };
    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }
    if (event.key === 'Enter') {
      setCurrentQuery(query);
      dispatch(
        fetchPdfDataExtractionRequest({
          query,
        }),
      );
    }
  };

  return isPDFDataExtractionFeatureEnabled ? (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="PDF Data Extraction">
        {/*TODO: permissions will be implemented later*/}
        {/*{user?.permissions?.documents === 2 && <PdfDataExtractionListPageActions />}*/}
      </TopBar>
      <PdfDataExtractionFilters
        filters={filters}
        selectedFilter={selectedFilter}
        onFilterChange={handleFilterChange}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onSearchKeyPress={handleSearchKeyPress}
      />
      <PDFDataExtractionTable searchQuery={currentQuery} />
    </Stack>
  ) : (
    !isPDFDataExtractionFeatureEnabled && (
      <FeatureNotSupportedDialog
        title={'PDF Data Extraction'}
        description={'Upload PDF invoices and receipts to automatically extract data for bulk processing.'}
      />
    )
  );
}

export default PdfDataExtractionListPage;
